import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ShoppingBag } from 'lucide-react';
interface Purchase {
  name: string;
  location: string;
  timeAgo: string;
}
const purchases: Purchase[] = [{
  name: 'Carlos M.',
  location: 'Ciudad de México',
  timeAgo: 'hace 3 minutos'
}, {
  name: 'María G.',
  location: 'Bogotá, Colombia',
  timeAgo: 'hace 7 minutos'
}, {
  name: 'Andrés R.',
  location: 'Lima, Perú',
  timeAgo: 'hace 12 minutos'
}, {
  name: 'Valentina S.',
  location: 'Buenos Aires',
  timeAgo: 'hace 18 minutos'
}, {
  name: 'Diego L.',
  location: 'Santiago, Chile',
  timeAgo: 'hace 25 minutos'
}, {
  name: 'Camila P.',
  location: 'Medellín, Colombia',
  timeAgo: 'hace 32 minutos'
}, {
  name: 'Roberto F.',
  location: 'Guadalajara, México',
  timeAgo: 'hace 41 minutos'
}, {
  name: 'Lucía H.',
  location: 'Quito, Ecuador',
  timeAgo: 'hace 48 minutos'
}, {
  name: 'Fernando T.',
  location: 'Monterrey, México',
  timeAgo: 'hace 55 minutos'
}, {
  name: 'Ana B.',
  location: 'Caracas, Venezuela',
  timeAgo: 'hace 1 hora'
}];
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/e3KrgVqNxWjazzASSe46FS/heylloyd-image-1770241548684.png';
const PRICE = '$6.39 USD';
const SHOW_DURATION = 6000; // visible 6 seconds
const INTERVAL = 20000; // every 20 seconds
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const showNext = useCallback(() => {
    setCurrentIndex(prev => (prev + 1) % purchases.length);
    setVisible(true);
    setTimeout(() => {
      setVisible(false);
    }, SHOW_DURATION);
  }, []);
  useEffect(() => {
    // First popup after 8 seconds (give user time to start reading)
    const initialTimeout = setTimeout(() => {
      showNext();
    }, 8000);
    // Then every 20 seconds
    const interval = setInterval(() => {
      showNext();
    }, INTERVAL);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [showNext]);
  const current = purchases[currentIndex];
  return <AnimatePresence data-id="element-194">
      {visible && <motion.div initial={{
      x: -100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -100,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} className="fixed bottom-6 left-6 z-50 max-w-sm" data-id="element-195">
          <div className="bg-white rounded-xl shadow-2xl border border-[#E5E0D8] overflow-hidden flex items-stretch" data-id="element-196">
            {/* Product image */}
            <div className="w-24 h-24 flex-shrink-0" data-id="element-197">
              <img src={PRODUCT_IMAGE} alt="Guía de Ansiedad" className="w-full h-full object-cover" data-id="element-198" />
            </div>

            {/* Content */}
            <div className="p-3 pr-8 flex flex-col justify-center min-w-0" data-id="element-199">
              <div className="flex items-center gap-1.5 mb-1" data-id="element-200">
                <ShoppingBag className="w-3.5 h-3.5 text-[#7C8B6F]" data-id="element-201" />
                <span className="text-xs text-[#7C8B6F] font-medium" data-id="element-202">
                  Compra verificada
                </span>
              </div>
              <p className="text-sm font-semibold text-[#2D2A26] truncate" data-id="element-203">
                {current.name}{' '}
                <span className="font-normal text-[#8D8A86]" data-id="element-204">
                  — {current.location}
                </span>
              </p>
              <p className="text-xs text-[#5D5A56] mt-0.5" data-id="element-205">
                Compró la guía por{' '}
                <span className="font-bold text-[#D4915D]" data-id="element-206">{PRICE}</span>
              </p>
              <p className="text-[10px] text-[#A5A29E] mt-1" data-id="element-207">
                {current.timeAgo}
              </p>
            </div>

            {/* Close button */}
            <button onClick={() => setVisible(false)} className="absolute top-2 right-2 text-[#A5A29E] hover:text-[#5D5A56] transition-colors" aria-label="Cerrar notificación" data-id="element-208">
              <X className="w-4 h-4" data-id="element-209" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}